import React, { useRef, useState } from 'react';
import { Video, Upload, X, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { uploadVideo } from '../lib/upload';

// Admin ad-video field: MP4/WebM/MOV, max 20MB, ~30s (checked client-side).
const VideoUpload = ({ value, onChange, folder = 'ads', hint = 'MP4, WebM o MOV - máx. 20 MB, 30 seg', testId = 'video-upload', className = '' }) => {
  const [busy, setBusy] = useState(false);
  const [pct, setPct] = useState(0);
  const input = useRef(null);

  const pick = async (file) => {
    if (!file) return;
    setBusy(true);
    setPct(0);
    try {
      const url = await uploadVideo(file, folder, setPct);
      onChange(url);
      toast.success('Video subido');
    } catch (e) {
      toast.error(e?.response?.data?.detail || e.message || 'No se pudo subir el video');
    } finally {
      setBusy(false);
      setPct(0);
    }
  };

  return (
    <div className={className} data-testid={testId}>
      <div className="relative w-full h-40 rounded-xl overflow-hidden bg-[#F7F8FA] border border-gray-200">
        {value ? <video src={value} className="w-full h-full object-cover" controls data-testid={`${testId}-preview`} />
          : <span className="w-full h-full flex items-center justify-center text-gray-300"><Video size={30} /></span>}
        {busy && <span className="absolute inset-0 bg-black/50 text-white text-xs font-bold flex flex-col items-center justify-center gap-1"><Loader2 size={18} className="animate-spin" />{pct}%</span>}
        {value && !busy && (
          <button type="button" data-testid={`${testId}-remove`} onClick={() => onChange('')} className="absolute top-1.5 right-1.5 w-6 h-6 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/80"><X size={13} /></button>
        )}
      </div>
      <div className="flex items-center gap-2 mt-2">
        <button type="button" data-testid={`${testId}-select`} disabled={busy} onClick={() => input.current?.click()} className="h-9 px-3 rounded-xl border border-gray-200 text-xs font-bold flex items-center gap-1.5 hover:bg-gray-50 disabled:opacity-50"><Upload size={15} /> Subir video</button>
        <p className="text-[11px] text-gray-400 leading-tight">{hint}</p>
      </div>
      <input ref={input} type="file" accept="video/mp4,video/webm,video/quicktime" className="hidden" onChange={(e) => { pick(e.target.files?.[0]); e.target.value = ''; }} />
    </div>
  );
};

export default VideoUpload;
